import {
  pricingPlansBundle,
  pricingPlansCall,
  pricingPlansChat,
} from '../config/billingPlansConfig';
import Company from '../interfaces/Company';
import { Price } from '../interfaces/Price';
import { Subscription } from '../interfaces/Subscription';

const ALL_V2_PLANS = [
  ...pricingPlansCall,
  ...pricingPlansChat,
  ...pricingPlansBundle,
] as Price[];

/**
 * Short label for the current subscription (navbar): config title + product line, Stripe name, or tier · type.
 */
export function resolveSubscribedPlanNavLabel(
  company: Company | null | undefined,
  subscription: Subscription | null | undefined
): string | null {
  const planId = company?.plan_id;
  if (planId) {
    const currentPlan = ALL_V2_PLANS.find(p => p.id === planId);
    if (currentPlan?.title) {
      const type =
        currentPlan.planType != null
          ? ` · ${currentPlan.planType.charAt(0).toUpperCase()}${currentPlan.planType.slice(1)}`
          : '';
      return `${currentPlan.title}${type}`;
    }
  }
  const name = subscription?.product_name?.trim();
  if (name) return name;
  if (company?.plan_tier && company?.plan_type) {
    const tier =
      company.plan_tier.charAt(0).toUpperCase() + company.plan_tier.slice(1);
    const planType =
      company.plan_type.charAt(0).toUpperCase() + company.plan_type.slice(1);
    return `${tier} · ${planType}`;
  }
  return null;
}
